import { render, staticRenderFns } from "./TravelClientConsent.vue?vue&type=template&id=3952e46f&"
import script from "./TravelClientConsent.vue?vue&type=script&lang=js&"
export * from "./TravelClientConsent.vue?vue&type=script&lang=js&"
import style0 from "./TravelClientConsent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TravelClientConsent.vue"
export default component.exports